export default {"src":"/pro/_next/static/media/mantle.c7f00881.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};